import React from "react";
import { Button } from "react-bootstrap";
import "./PendingIntroActions.scss";

const PendingIntroActions = ({ onNotFit, onView, onAccept, accepting, busy }) => (
  <div className="property-action pending-intro-actions flex-shrink-0">
    <Button
      variant="light"
      className="btn-decline"
      disabled={busy}
      onClick={onNotFit}
    >
      Mark not a fit
    </Button>
    <Button
      variant={onAccept ? "outline" : "primary"}
      className={onAccept ? "btn-outline-primary" : undefined}
      disabled={busy}
      onClick={onView}
    >
      View
    </Button>
    {onAccept ? (
      <Button variant="primary" disabled={busy} onClick={onAccept}>
        {accepting ? "Accepting..." : "Accept and reply"}
      </Button>
    ) : null}
  </div>
);

export default PendingIntroActions;
